module.exports = __webpack_public_path__ + "static/media/01.3fe1be72.png";